import { Component, OnInit } from '@angular/core';
import { ssApiService } from '../../services/ss-api.service';
import { GlobalService } from '../../services/global.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { ToChargeItemArray, ToChargeItem } from '../../../app/models/ss-api/responses/to.charge.item';
import { GetToChargeRequest } from '../../../app/models/ss-api/requests/get.to.charge.request';
import { SortBot } from '../../../app/helpers/sort';
import { Router } from '@angular/router';
import { Angular2Csv } from 'angular2-csv';

import * as moment from 'moment';
import { LicenseManager } from '../../managers/License.manager';
import { HoldStatsRequest } from '../../../app/models/ss-api/requests/hold.stats.request';
import { BillingCycleTypes } from '../../../app/models/domain/invoice';
import { HoldStatisticsItemArray, HoldStatusesArray, HoldStatuses } from '../../../app/models/ss-api/responses/hold.statistics.item';
import { HoldStatus } from '../../models/domain/hold.item';

import { GetHoldStatusPipe } from '../../pipes/hold.pipes'

@Component({
    selector: 'hold-report',
    templateUrl: './hold.report.component.html',
	styleUrls: ['./hold.report.component.scss'],
	providers : [ GetHoldStatusPipe ]
})

export class HoldReportComponent implements OnInit {
    IsBusy: boolean = false;

	holdStatistics : HoldStatisticsItemArray;

	
	dateStart : Date = new Date();
	dateStop : Date = new Date();


	filterString : string = '';

	resultRows : number = 25;
    firstResult : number = 0;
    lastResult : number = 24;

    constructor(private api: ssApiService,
        private gb: GlobalService,
        private sweetAlert: SweetAlertService,
		private router: Router,
		private holdPipe : GetHoldStatusPipe 
		) { }

	
    ngOnInit() {
		this.gb.SetPageTitle('Hold Report');
		this.GetHoldReport();

    }


	/**
	 * GetHoldReport - Loads report data based on selected options in component
	 */
	GetHoldReport() {
		this.IsBusy = true;

		let request = new HoldStatsRequest();
		request.HoldStatuses = new HoldStatusesArray();
		request.HoldStatuses.push( HoldStatuses.Active );
		request.StartDate = null;
		request.EndDate = null;

		let disposable = this.api.GetHoldStatistics( request ).subscribe( result => {
			disposable.unsubscribe();
			this.IsBusy = false;

			
			this.holdStatistics = result.Data;
			console.log("GetHoldStatistics : ", result);
			console.log("holdStatistics : ", this.holdStatistics);

		});

	}


	/**
	 * MemberClick Function
	 * @param id - Member ID
	 */
    MemberClick(id: number) {
		this.router.navigate(['/member-profile', id]);
    }


	/**
	 * LicenseClick Function
	 * @param {string} LicenseKey - License Key to load
	 */
	LicenseClick(LicenseKey: string) {
		
		this.IsBusy = true;
        let manager = new LicenseManager();
		
		manager.OnDataLoaded.subscribe(response => {
            this.IsBusy = false;
        });
		
		manager.Load(LicenseKey, true);
		
    }


	/**
	 * SortBy - sort data in data set
	 * @param sortVar1 - String name identifying name of variable to use for sorting
	 * @param sortVar2 - (optional) secondary, or sub variable name to use when sorting
	 */
	SortBy(sortVar1: string, sortVar2: string = '') {
        this.holdStatistics = SortBot.SortAuto( this.holdStatistics, sortVar1, sortVar2 );
    }
	


	paginateInvoices(e) {
        this.firstResult = e.page * e.rows;
        this.lastResult = this.firstResult + e.rows;
	}
	


	ExportToCSV() {

		let options = {
            fieldSeparator: ',',
            quoteStrings: '"',
            decimalseparator: '.',
            showLabels: true,
            headers: ['Created', 'Member', 'CDKey', 'Product', 'StartDate', 'EndDate', 'Months', 'Status']
        };

        let ExportData = [];

		this.holdStatistics.forEach( ( item ) => {

			let myStatus = this.holdPipe.transform(item.HoldStatus);

			ExportData.push({
                Created: item.DateTimeCreated,
				Member : item.MemberName,
				CDKey : item.LicenseKey,
				Product : item.ProductName,
				StartDate : item.HoldStartDate,
				EndDate : item.HoldEndDate,
				Months : item.HoldMonths,
				Status : myStatus
            });
        });

		new Angular2Csv(ExportData, 'HoldReport', options);
		
	}


}
